const statementsPT = {
    "view": {
        "table": {
            "title": "Sua lista de Declarações",
            "column": {
                "type": "Tipo",
                "year": "Ano",
                "month": "Mês",
                "issue_year": "Ano de Emissão",
                "issue_month": "Mês de Emissão",
                "description": "Descrição",
                "amount": "Quantia",
                "status": "Status",
                "details": "Detalhes",
                "overview": "Visão Geral"
            },
            "placeholder": {
                "search": "Pesquisar..."
            },
            "label": {
                "status_open": "Aberto",
                "status_paid": "Pago",
                "type_licensing": "Licenciamento",
                "type_regular": "Regular",
                "type_audio_mastering_services": "Masterização de Áudio - Serviços",
                "type_vinyl_earnings": "Ganhos de Vinil",
                "type_offset": "Compensação",
                "type_not_known": "Desconhecido",
                "month_january": "Janeiro",
                "month_february": "Fevereiro",
                "month_march": "Março",
                "month_april": "Abril",
                "month_may": "Maio",
                "month_june": "Junho",
                "month_july": "Julho",
                "month_august": "Agosto",
                "month_september": "Setembro",
                "month_october": "Outubro",
                "month_november": "Novembro",
                "month_december": "Dezembro"
            },
            "button": {
                "download": "Baixar",
                "exportCsv": "Exportar CSV"
            }
        },
        "message": {
            "subscriptionUpgrade": "Seu plano de assinatura atual não suporta este recurso. Por favor, <1>atualize</1> seu plano de assinatura para aproveitar este recurso.",
            "subscriptionExpired": "Sua assinatura expirou. Por favor, <1>retome</1> sua assinatura para aproveitar este recurso.",
            "noAccess": "Você não tem acesso a este módulo, por favor entre em contato com a equipe de suporte para mais informações."
        }
    }
};

export default statementsPT;